import React, { Fragment } from 'react';

const spinner = () => {
    return (
        <div className="pt-spinner pt-small">
            <div className="pt-spinner-svg-container">
                <svg viewBox="0 0 100 100">
                    <path className="pt-spinner-track" d="M 50,50 m 0,-44.5 a 44.5,44.5 0 1 1 0,89 a 44.5,44.5 0 1 1 0,-89"></path>
                    <path className="pt-spinner-head" d="M 94.5 50 A 44.5 44.5 0 0 0 50 5.5"></path>
                </svg>
            </div>
        </div>
    );
}

const LoadingButton = props => {
    const { text, isLoading, className, loadingText, disabled } = props;
    const loader = () => {
        return (
            <Fragment>
                { loadingText ? <span className="loading-button">{loadingText}</span> : null }
                { spinner() }
            </Fragment>
        )
    }

    return (
        <button type="button"
            disabled={isLoading || disabled}
            className={className}
            onClick={() => props.onClick()}>
            { isLoading ? loader() : text }  
        </button>
    );
}

export default LoadingButton;


// WEBPACK FOOTER //
// ./src/components/widgets/LoadingButton.jsx